module.exports = __webpack_public_path__ + "static/media/platinum-box.0520e338.png";